module.exports = __webpack_public_path__ + "img/geoLogoColor.433b0723.png";